import React from "react";
import SimpleReactValidator from "simple-react-validator";
import CreateParkingMap from "./create-parking-map";

class CreateNewParking extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.state = {
      active: true,
      latitude: null,
      longitude: null,
    };

    this.validator = new SimpleReactValidator({
      locale: "en",
      element: message => <div className="text-danger">{message}</div>
    });
  }

  handleChange = (arr) => {
    const state = Object.assign({}, this.state);
    arr.forEach(item => {
      state[item.key] = item.value;
    });

    this.setState(state);
  };

  handleSave = () => {
    if (this.validator.allValid()) {
      this.props.onAdd(this.state);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const {
      latitude,
      longitude,
      active,
    } = this.state;

    return (
      <div>
        <div className="">
          <div className="row align-bottom justify-content-between align-items-end">
            <div className="col-3">
              <div className="form-group">
                <label>Is Active?</label>
                <select
                  className="form-control form-control-sm"
                  value={String(active)}
                  onChange={(ev) => {
                    this.setState({
                      active: ev.target.value === "true"
                    });
                  }}>
                  <option value={"true"}>Yes</option>
                  <option value={"false"}>No</option>
                </select>
              </div>
            </div>
            <div className="col-2">
              <button
                className="btn btn-sm btn-success btn-block mb-3"
                onClick={this.handleSave}
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <CreateParkingMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: 600 }}/>}
          containerElement={<div style={{ minHeight: 600 }}/>}
          mapElement={<div style={{ minHeight: 600 }}/>}
          onChange={this.handleChange}
          latitude={latitude}
          longitude={longitude}
          color={active ? "#84ff00" : "#808080"}
        />
        {this.validator.message("latitude", latitude, "required")}
        {this.validator.message("longitude", longitude, "required")}
      </div>
    );
  }
}

export default CreateNewParking;



// WEBPACK FOOTER //
// ./src/views/pages/scooter/parking/create-new-parking.js